import { memo } from "react";
import { Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import verifiedEmailIcon from "assets/img/auth/verified-email.svg";
import { ErrorAlert } from "../../signIn/components/ErrorAlert";

interface Step2EmailVerifiedProps {
  onContinue: () => void;
  onBack: () => void;
  isContinueDisabled: boolean;
  isLoading: boolean;
  loadingText?: string;
  infoMessage?: string | null;
  errorMessage?: string | null;
}

export const EmailVerified = memo(function EmailVerified({
  onContinue,
  onBack,
  isContinueDisabled,
  isLoading,
  loadingText,
  infoMessage,
  errorMessage,
}: Step2EmailVerifiedProps) {
  console.log("EmailVerified",errorMessage , loadingText );
  return (
    <Flex direction="column" alignItems="center" textAlign="center" w="100%">
      <Flex mb="24px" alignItems="center" justifyContent="center" gap="16px">
        <Image src={verifiedEmailIcon} w="97px" h="97px" alt="Verified email icon" />
      </Flex>
 
      {!errorMessage && loadingText && !isLoading && !infoMessage && (
        <>
          <Heading fontSize="24px" fontWeight="600" mb="12px" color="navy.700">
            Email verified
          </Heading>
          <Text fontSize="16px" color="#0B0E10" mb="32px" maxW="400px">
            Your email address is verified. Thank you for confirming!
          </Text>
        </>
      )}

      {!errorMessage && infoMessage ? (
        <Text fontSize="16px" color="#0B0E10" mb="16px" maxW="400px">
          {infoMessage}
        </Text>
      ) : null}

      {errorMessage && <ErrorAlert message={errorMessage} />}

      {infoMessage && !errorMessage ? (
        <Button
          w="100%"
          h="48px"
          bgColor="white"
          color="#3A7BFF"
          borderRadius="24px"
          fontSize="14px"
          fontWeight="600"
          border="1px solid #3A7BFF"
          mb="16px"
          _hover={{
            bgColor: "#3A7BFF",
            color: "#FFF",
          }}
          _active={{
            bgColor: "#FFFFFF",
            color: "#3A7BFF",
          }}
          onClick={onBack}
        >
          Back
        </Button>
      ) : errorMessage ? (
        <Button
          w="100%"
          h="48px"
          bgColor="white"
          color="#3A7BFF"
          borderRadius="24px"
          fontSize="14px"
          fontWeight="600"
          border="1px solid #3A7BFF"
          mb="16px"
          _hover={{
            bgColor: "#3A7BFF",
            color: "#FFF",
          }}
          _active={{
            bgColor: "#FFFFFF",
            color: "#3A7BFF",
          }}
          onClick={onBack}
        >
          Back
        </Button>
      ) : (
        <Button
          w="100%"
          h="48px"
          fontSize="16px"
          bgColor="#3A7BFF"
          fontWeight="600"
          color="#FFFFFF"
          borderRadius="25px"
          border="1px solid #2C63E5"
          _hover={{
            bgColor: "#FFFFFF",
            color: "#2C63E5",
          }}
          _active={{
            bgColor: "#FFFFFF",
            color: "#2C63E5",
          }}
          _loading={{ pointerEvents: "none" }}
          onClick={onContinue}
          isDisabled={isContinueDisabled}
          isLoading={isLoading}
        >
          Continue
        </Button>
      )}
    </Flex>
  );
});
